(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-filter-shortcut]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();

      const targetId = button.dataset.target;
      const drawer = document.querySelector('.mobile-facets__disclosure'); // your main drawer <details>
      const filterToOpen = document.getElementById(targetId);

      if (!filterToOpen) return;

      // Open the mobile filters drawer if it's not already open
      if (!drawer.hasAttribute('open')) {
        drawer.setAttribute('open', '');

        drawer.classList.add('menu-opening');
        document.body.classList.add('menu-drawer-opening');

        const drawerSummary = drawer.querySelector('summary');
        if (drawerSummary) drawerSummary.setAttribute('aria-expanded', true);
      }

      // Determine target labels
      const targetLabel = button.dataset.filterTargetLabel;
      let labels = [targetLabel];

      // Special case: Band size and Cup size should both open together
      if (targetLabel === 'band-size' || targetLabel === 'cup-size') {
        labels = ['band-size', 'cup-size'];
      }

      // Open each matching filter in the drawer
      labels.forEach((label) => {
        const details = drawer.querySelector(`[data-filter-label="${label}"]`);
        if (details && !details.hasAttribute('open')) {
          const summary = details.querySelector('summary');
          if (summary) summary.click();
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
